import { action, makeObservable, observable } from 'mobx';
import orderBy from 'lodash/orderBy';

import { LegalEntityData } from 'chaika-frontend-types/frontend-cms';
import { LegalEntityType } from 'chaika-enums';

import { SimpleList } from '@store/models/SimpleList';

import { LegalEntityFilterParams } from '@organization/queries/matchesLegalEntityFilter';

export class LegalEntityList extends SimpleList<LegalEntityData, LegalEntityFilterParams> {
    public static Name = 'legalEntityList' as const;

    @observable private currentCountryIds = new Set<string>();

    constructor(params?: LegalEntityData[]) {
        super(params);
        makeObservable(this);
    }

    public isInCurrentCountry(id: string): boolean {
        return this.currentCountryIds.has(id);
    }

    @action
    public setCurrentCountryIds(ids: string[]): void {
        this.currentCountryIds = new Set(ids);
    }

    protected getOrderedValues(params: LegalEntityData[]): LegalEntityData[] {
        return orderBy(params, ({ type }) => type === LegalEntityType.Clinic, 'desc');
    }

    protected filterValue(
        value: LegalEntityData,
        { executeId, status, type, statuses, ids, query, types }: LegalEntityFilterParams,
    ): boolean {
        return (
            (this.filterFieldValueIncludesString(value, query, 'name') ||
                this.filterFieldValueIncludesString(value, query, 'abbreviation')) &&
            this.filterExecuteFieldValue(value, executeId, 'id') &&
            this.filterFieldValue(value, status, 'status') &&
            this.filterFieldValueByArray(value, statuses, 'status') &&
            this.filterFieldValue(value, type, 'type') &&
            this.filterFieldValueByArray(value, ids, 'id') &&
            this.filterFieldValueByArray(value, types, 'type')
        );
    }
}

export const legalEntityList = new LegalEntityList();
